import { useEffect, useRef } from 'react';

import Canvas, { ICanvasRef } from '../../../../../../com/canvas/Canvas';
import { Grid } from './grid/Grid';

import './SpotsSizeSelector.scss';

interface ISpotsSizeSelector {
  onGridSizeSelected: (rows: number, columns: number) => void
}

export const SpotsSizeSelector: React.FC<ISpotsSizeSelector> = (props) => {

  const canvasRef = useRef<ICanvasRef>(null);

  const canvasWidth = 218;
  const canvasHeigth = 218;

  const createGrid = () => {
      var grid = new Grid();
      grid.onGridSizeSelected = props.onGridSizeSelected;
      grid.init();

      canvasRef.current!.addChild(grid);
  }

  useEffect(() => {
    createGrid();
  }, [])

  return (
    <Canvas
      ref={canvasRef}
      id={'spotsSizeSelector'}
      width={canvasWidth}
      height={canvasHeigth}
    />
  );
};
